/* eslint-disable no-unused-vars */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import moment from 'moment-timezone';
import Autocomplete from 'react-google-autocomplete';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { travelLabels } from './EventCategory';
import DatePicker from '../../utils/FormWidgets/DatePicker';
import Rq from '../../utils/FormWidgets/RequireField';
import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import AirportSearcher from '../../utils/FormWidgets/AirportSearcher';
import TimePicker from '../../utils/FormWidgets/TimePicker';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import {
  getTimeWithOffset,
  getLocationDescription,
  LocationDescription,
} from '../../../infrastructure/utils/common';

import { setTopPosition } from '../../utils/Styles/SetTopPosition';

class State {
  labels = travelLabels.find(label => label.Name === 'Flight');
}

const Label = styled(ControlLabel)`
  width: 100%;
`;

export default class FlightForm extends React.Component {
  state = new State();
  instance = React.createRef();
  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { event } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (event.travelType) {
      this.setState({
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        labels: travelLabels.find(label => label.Name === event.travelType),
      });
    }
  }

  componentDidUpdate() {
    if (this.instance.current) {
      this.onFocus();
    }
  }
  onFocus = () => {
    setTopPosition('.pac-container', this.instance);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.instance.current.addEventListener('focusin', () => {
      setTopPosition('.pac-container', this.instance);
    });
  };

  handleEventNameChange = ({ target }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    const pass = {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      ...event.passengers,
      flightNumber: target.value,
    };
    handleTravelDataChange({
      ...event,
      passengers: pass,
    });
  };

  locationSelected = async val => {
    if (val.place_id === undefined) {
      return;
    }
    let image;
    const location = await getLocationDescription(val, true);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    if (val.photos) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      image = {
        url: val.photos[0].getUrl(),
      };
      handleTravelDataChange({
        ...event,
        eventLocation: location,
        eventLocationFrom: location,
      });
    }
  };

  locationChanged = ({ target }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    const newLocation = {
      address: target.value.length > 0 ? target.value : undefined,
    };
    handleTravelDataChange({
      ...event,
      eventLocation: newLocation,
      eventLocationFrom: newLocation,
    });
  };

  onFromSelected = location => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    let addr = `${location.name} ${location.city}`;
    if (location.country !== 'United States') {
      addr += ` ${location.country}`;
    }
    handleTravelDataChange({
      ...event,
      eventLocationFrom: {
        latitude: location.latitude,
        longitude: location.longitude,
        address: addr,
      },
      startTz: location.timezone,
      startTimeOffset: location.offset * 60,
    });
  };

  onToSelected = location => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    let addr = `${location.name} ${location.city}`;
    if (location.country !== 'United States') {
      addr += ` ${location.country}`;
    }
    handleTravelDataChange({
      ...event,
      eventLocationTo: {
        latitude: location.latitude,
        longitude: location.longitude,
        address: addr,
      },
      endTz: location.timezone,
      endTimeOffset: location.offset * 60,
    });
  };

  handleTravelTypeChange = value => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    handleTravelDataChange({
      ...event,
      travelType: value,
      eventLocationFrom:
        value === 'Flight'
          ? // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            new LocationDescription()
          : // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            event.eventLocationFrom,
      eventLocationTo:
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        value === 'Flight' ? new LocationDescription() : undefined,
    });
    this.setState({ labels: travelLabels.find(label => label.Name === value) });
  };

  handleFlightTypeChange = value => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    handleTravelDataChange({
      ...event,
      flightType: value,
    });
  };

  handleCheckoutDateChange = value => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    if (!value) {
      handleTravelDataChange({
        ...event,
        startTime: -1,
        endTime: -1,
        eventDate: value,
        checkoutDate: value,
        timeTBD: true,
        dateTBD: true,
      });
      return;
    }
    handleTravelDataChange({
      ...event,
      checkoutDate: value,
      dateTBD: false,
    });
  };

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      event,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleDateChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      startDate,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      TBDTime,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      partyLocation,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleStartTimeChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleEndTimeChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tz,
    } = this.props;
    const { labels } = this.state;
    const flight =
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      event.travelType === undefined || event.travelType === 'Flight';
    return (
      <Fragment>
        <FormGroup
          className='col-md-6 col-sm-6 col-xs-12'
          style={{ paddingLeft: '0px' }}
        >
          <ControlLabel>Travel Type</ControlLabel>
          <SimpleSelect
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            onChange={this.handleTravelTypeChange}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            value={event.travelType}
            data={[
              {
                value: 'Flight',
                label: 'Flight',
                icon: 'fas fa-plane-arrival',
              },
              { value: 'Train', label: 'Train', icon: 'fas fa-subway' },
              { value: 'Drive', label: 'Drive', icon: 'fas fa-car' },
              { value: 'Other', label: 'Other', icon: 'fas fa-walking' },
            ]}
          />
        </FormGroup>
        <FormGroup
          className='col-md-6 col-sm-6 col-xs-12'
          style={{ marginTop: '30px', paddingLeft: '0px', paddingRight: '0px' }}
        >
          <SimpleSelect
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            onChange={this.handleFlightTypeChange}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            value={event.flightType}
            data={[
              { value: 'Arriving', label: `Arriving to ${partyLocation}` },
              { value: 'Departing', label: `Returning from ${partyLocation}` },
            ]}
          />
        </FormGroup>
        {flight && (
          <Fragment>
            <FormGroup>
              <Label>
                {
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
                  // @ts-ignore
                  labels.From
                }
                <Rq />
              </Label>
              <AirportSearcher
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                onSelected={this.onFromSelected}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.eventLocationFrom.address}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>
                {
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
                  // @ts-ignore
                  labels.To
                }
                <Rq />
              </ControlLabel>
              <AirportSearcher
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                onSelected={this.onToSelected}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.eventLocationTo.address}
              />
            </FormGroup>
            <FormGroup controlId='eventName'>
              <ControlLabel>Airline and Flight Number</ControlLabel>
              <FormControl
                type='text'
                onChange={this.handleEventNameChange}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.passengers.flightNumber}
              />
            </FormGroup>
          </Fragment>
        )}
        {!flight && (
          <FormGroup controlId='from'>
            <Label>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed}
                // @ts-ignore
                labels.From
              }
              <Rq />
            </Label>
            {
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              <div ref={this.instance} onMouseMove={this.onMouseMove}>
                {
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  <Autocomplete
                    className='form-control'
                    types={['establishment']}
                    onPlaceSelected={this.locationSelected}
                    onChange={this.locationChanged}
                    value={
                      // TODO: Fix this the next time the file is edited.
                      // eslint-disable-next-line react/prop-types
                      event.eventLocationFrom && event.eventLocationFrom.address // TODO: Fix this the next time the file is edited.
                        ? // eslint-disable-next-line react/prop-types
                          event.eventLocationFrom.address
                        : ''
                    }
                  />
                }
              </div>
            }
          </FormGroup>
        )}
        <div className='row'>
          <div className='day-picker-inp col-md-6 col-sm-8 col-xs-12'>
            <FormGroup controlId='eventDate'>
              <DatePicker
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                label={labels.Start}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.eventDate}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
                handleChange={handleDateChange}
                dayPickerProps={{
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  initialMonth: getTimeWithOffset(
                    moment(startDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                  ),
                }}
              />
            </FormGroup>
          </div>
          <FormGroup
            controlId='startTime'
            style={{ paddingTop: '30px' }}
            className='col-md-4 col-sm-4 col-xs-12'
          >
            <TimePicker
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              onChange={handleStartTimeChange}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
              tbd={TBDTime}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              value={event.startTime}
            />
          </FormGroup>
        </div>
        <div className='row'>
          <div className='day-picker-inp col-md-6 col-sm-8 col-xs-12'>
            <FormGroup controlId='checkOutDate'>
              <DatePicker
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                label={labels.End}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.checkoutDate}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
                handleChange={this.handleCheckoutDateChange}
                dayPickerProps={{
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  initialMonth: getTimeWithOffset(
                    moment(startDate).tz(tz).format('YYYY-MM-DDTHH:mm:000Z')
                  ),
                }}
              />
            </FormGroup>
          </div>
          <FormGroup
            controlId='endTime'
            style={{ paddingTop: '30px' }}
            className='col-md-4 col-sm-4 col-xs-12'
          >
            <TimePicker
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              onChange={handleEndTimeChange}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
              tbd={TBDTime}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              value={event.endTime}
            />
          </FormGroup>
        </div>
      </Fragment>
    );
  }
}
